'use strict';

const { loadUserFactory } = require('./loadUser.js');

const _resolveUser = (name, navigator_) => async ($stateParams, $state, auth, tmhDynamicLocale) => {
	const { loadUser } = loadUserFactory(navigator_);

	// locale is set on: user.settings.locale
	const noAuthNavigationKeys = ['SwitchAccounts', 'LatestDocId', 'LatestLegalDoc'];

	if (noAuthNavigationKeys.includes(name)) {
		return;
	}

	return await loadUser($stateParams, $state, auth, tmhDynamicLocale).then(user => {
		const localAccess = { ...user.localAccess };
		localAccess.roles = localAccess.roles ? [...localAccess.roles.values()] : [];
		localAccess.permissions = localAccess.permissions ? [...localAccess.permissions.values()] : [];
		return {
			...user,
			localAccess: localAccess
		};
	});
};

const _resolveFeatureFlags = requiredPermission => ($stateParams, pmtFeatureFlagService) => {
	if (requiredPermission === null) {
		return;
	}

	return pmtFeatureFlagService.getFeatures($stateParams.site);
};

const elm =
	(navigator_, pmtEnv) =>
	({
		name,
		moduleName,
		url,
		requiredPermission = null,
		argsResolver = ['$stateParams', () => null],
		pageTitle = null,
		redirectTo,
		subscriptions = ['$stateParams', () => null]
	}) => {
		return {
			name: name,
			url: url,
			component: 'pmtElm',
			requiredPermission: requiredPermission,
			redirectTo,
			reloadOnSearch: false,
			resolve: {
				module: () => moduleName,
				args: argsResolver,
				user: [
					'$stateParams',
					'$state',
					'auth',
					'tmhDynamicLocale',
					_resolveUser(name, navigator_)
				],
				featureFlags: [
					'$stateParams',
					'pmtFeatureFlagService',
					_resolveFeatureFlags(requiredPermission)
				],
				pmtEnv: () => pmtEnv,
				pageTitle: () => pageTitle,
				subscriptions: subscriptions
			}
		};
	};

const elmWithFilter = (navigator_, pmtEnv) => props => {
	return {
		...elm(navigator_, pmtEnv)(props),
		component: 'pmtElmFilter'
	};
};

const constructElmFunctions = (navigator_, pmtEnv) => {
	return {
		elm: elm(navigator_, pmtEnv),
		elmWithFilter: elmWithFilter(navigator_, pmtEnv)
	};
};

module.exports = {
	constructElmFunctions
};
